import { Message } from "../../../../models"
import { ErrorFetchingAction, FetchErrorInfo, FetchRequestActions, StartFetchingAction, SuccessFetchingAction } from "../../../../utils/request-actions-helpers/createRequestActions"
import {getUpdateLastUserEnterChatDMActionTypes, UpdateLastChatAdditionalData} from './actions/updateLastUserEnterChat';
import {GetMessagesAdditionalData, getChatMessagesActionTypes} from './actions/getMessages';
import { postMessageActionTypes, PostMessageAdditionalData, UpdateLatestMessageAction, UPDATE_LATEST_MESSAGE } from "./actions";
import { isExistMessage, withUpdateMessage, withFilterMessagesById } from "../../../../utils";

export interface MessageState {
    item: Message
    isDeleting: boolean
    deleteError?: FetchErrorInfo
}

export interface ChatMessagesState {
    messages: MessageState[]
    isFetching: boolean
    isPosting: boolean
    isFetchingMore?: boolean
    messagesPage?: number
    hasMoreMessages?: boolean
    fetchError?: FetchErrorInfo
    postError?: FetchErrorInfo
}

export interface MessagesState {
    data: {
        [chatUId: string]: ChatMessagesState | undefined
    }
}

const initialChatMessagesState: ChatMessagesState = {
    messages: [],
    isFetching: false,
    isPosting: false,
    isFetchingMore: false,
    messagesPage: 0,
    hasMoreMessages: false
}

export const initialMessagesState: MessagesState = {
    data: {}
}
type MessagesAdditionalData = UpdateLastChatAdditionalData | GetMessagesAdditionalData | PostMessageAdditionalData | UpdateLatestMessageAction

export const messagesReducer = (state: MessagesState = initialMessagesState, action: FetchRequestActions<Message[], MessagesAdditionalData>): MessagesState => {
    switch (action.type) {
        case UPDATE_LATEST_MESSAGE: {
            const latestCommentAction = action as UpdateLatestMessageAction;

            const {chatUId, message} = latestCommentAction
            const documentComments = (state.data[chatUId] || { ...initialChatMessagesState })

            const prevMessages = documentComments.messages;
            const existMessage = isExistMessage(message.id, prevMessages);

            if(existMessage){
                return state;
            }

            const messageState: MessageState = {
                item: message,
                isDeleting: false
            }
            
            let newData: ChatMessagesState = {
                ...documentComments,
                messages:  [messageState, ...documentComments.messages]
            }

            const newState: MessagesState = {
                data: {
                    ...state.data,
                    [chatUId]: newData
                }
            }
            return newState 

        }
        case getUpdateLastUserEnterChatDMActionTypes.start: {
            return state
        }
        case getUpdateLastUserEnterChatDMActionTypes.success: {
            return state
        }
        case getUpdateLastUserEnterChatDMActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<UpdateLastChatAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialChatMessagesState }
            const newState: MessagesState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.chatUId]: {
                        ...documentMessages,
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case getChatMessagesActionTypes.start: {
            const startFetchingAction = action as StartFetchingAction<GetMessagesAdditionalData>
            if (!startFetchingAction.additionalData) {
                return state
            }
            const newState: MessagesState = {
                data: {
                    ...state.data
                }
            }
            const {chatUId, messagesPage} = startFetchingAction.additionalData
            const documentCommmentsState = state.data[chatUId] || { ...initialChatMessagesState }
            newState.data[chatUId] = {
                ...documentCommmentsState,
                isFetching: messagesPage as number === 0,
                isFetchingMore: messagesPage as number > 0 
            }

            return newState   
        }
        case getChatMessagesActionTypes.success: {
            const successAction = action as SuccessFetchingAction<Message[], GetMessagesAdditionalData>
            if (!successAction.additionalData) {
                return state
            }
            const {chatUId, messagesPage} = successAction.additionalData
            const documentMessages = (state.data[chatUId] || { ...initialChatMessagesState })

            const resultMessages = successAction.result.map(x => {
                const messageState: MessageState = {
                    item: x,
                    isDeleting: false
                }
                return messageState
            }).sort((resA, resB) => {
                return new Date(resB.item.creationDateTime).getTime() - new Date(resA.item.creationDateTime).getTime()
            });
            //tmp api bug
            const newMessages =  withFilterMessagesById([ ...resultMessages,...documentMessages.messages,]);

            let newData: ChatMessagesState = {
                ...documentMessages,
                isFetching: false,
                isFetchingMore: false,
                hasMoreMessages:  resultMessages.length > 0,
                messagesPage,
                messages:  messagesPage as number > 0 ? newMessages : resultMessages
            }

            const newState: MessagesState = {
                data: {
                    ...state.data,
                    [chatUId]: newData
                }
            }
            return newState 
        }
        case getChatMessagesActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<GetMessagesAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialChatMessagesState }
            const newState: MessagesState = {
                data: {
                    ...state.data,
                    [errorAction.additionalData.chatUId]: {
                        ...documentMessages,
                        isFetching: false,
                        messages: [],
                        fetchError: errorAction.error
                    }
                }
            }
            return newState
        }
        case postMessageActionTypes.start: {
            const postAction = action as StartFetchingAction<PostMessageAdditionalData>
            if (!postAction.additionalData) {
                return state
            }
            const { chatUId } = postAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialChatMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: true
                    }
                }
            }
        }
        case postMessageActionTypes.success: {
            const successPosting = action as SuccessFetchingAction<Message, PostMessageAdditionalData>
            if (!successPosting.additionalData) {
                return state
            }

            const { chatUId } = successPosting.additionalData
            const documentMessages = state.data[chatUId] || { ...initialChatMessagesState }

            const prevMessages = documentMessages.messages;
            const existMessage = isExistMessage(successPosting.result.id, prevMessages);

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        messages: existMessage ? [...withUpdateMessage(prevMessages, successPosting.result)] : [
                            ...documentMessages.messages,
                            { item: successPosting.result, isDeleting: false }
                        ]
                    }
                }
            }
        }
        case postMessageActionTypes.error: {
            const errorAction = action as ErrorFetchingAction<PostMessageAdditionalData>
            if (!errorAction.additionalData) {
                return state
            }
            const { chatUId } = errorAction.additionalData
            const documentMessages = state.data[chatUId] || { ...initialChatMessagesState }

            return {
                data: {
                    ...state.data,
                    [chatUId]: {
                        ...documentMessages,
                        isPosting: false,
                        postError: errorAction.error
                    }
                }
            }
        }
        default:
            return state
    }
}